import { InternalStepOption } from '@booking-booster-client/models';

export const step1: InternalStepOption = {
  anchorId: 'accounting-section',
  stepId: 'accounting-section',
  titleTranslationKey: 'ui_tours.settings_accounting.step1.title',
  contentTranslationKey: 'ui_tours.settings_accounting.step1.content',
  route: 'settings/accounting',
};
